<template>
  <div class="home">
    SUCCESS!
  </div>
</template>

<script>
//import { useToast } from "vue-toastification";
//const toast = useToast();

export default {
  name: 'ViewMercadoSuccess',
  mounted() {
    
  },
  data() {
    return {
      
    };
  },  
  methods: {
    
  },
  
};
</script>

<style scoped>

</style>
